import { ref, watch, computed } from '@vue/composition-api'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import dbOrders from '@/models/orders'

export default function useInvoicesList() {
  // Use toast
  const toast = useToast()

  const refOrdersListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'order_id', label: '#', sortable: true },
    { key: 'status', sortable: true },
    { key: 'budget', sortable: true },
    { key: 'providers', sortable: true },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalOrders = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refOrdersListTable.value ? refOrdersListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalOrders.value,
    }
  })

  const refetchData = () => {
    // refOrdersListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const fetchOrders = async (ctx, callback) => {
    try {
      const response = await dbOrders.getAll({
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
      })
      callback(response.data.orders)
      totalOrders.value = response.data.total
    } catch (e) {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Error fetching orders',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    }
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveOrdersStatusVariantAndIcon = status => {
    if (status === 'PENDING') return { variant: 'info', icon: 'ClockIcon' }
    if (status === 'SENT') return { variant: 'primary', icon: 'SendIcon' }
    if (status === 'RECEIVED') return { variant: 'success', icon: 'CheckCircleIcon' }
    if (status === 'CANCELLED') return { variant: 'danger', icon: 'XOctagonIcon' }

    // TODO: check status for orders

    if (status === 'PENDING') return { variant: 'warning', icon: 'HelpCircleIcon' }
    return { variant: 'secondary', icon: 'XIcon' }
  }

  const resolveProviderAvatarVariant = status => {
    if (status === 'ACCREDITED') return 'primary'
    if (status === 'REMINDER') return 'info'
    if (status === 'PAID') return 'success'
    if (status === 'NOT PAID') return 'warning'
    if (status === 'PENDING') return 'warning'
    if (status === 'CANCELLED') return 'danger'
    return 'primary'
  }

  return {
    fetchOrders,
    tableColumns,
    perPage,
    currentPage,
    totalOrders,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refOrdersListTable,

    statusFilter,

    resolveOrdersStatusVariantAndIcon,
    resolveProviderAvatarVariant,

    refetchData,
  }
}
